import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import CircularProgress from "@mui/material/CircularProgress";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import Popup from "layouts/applications/popup/Popup";
import { Card } from "@mui/material";

import { Formik, Form } from "formik";

import initialValues from "./schemas/initialValues";
import form from "./schemas/form";
import validationSchema from "./schemas/validations";

import CloseIcon from "@mui/icons-material/Close";

// Data
import { fetchPlans, fetchSpecialPlans, sendSpecialPlan } from "services/plan";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";

function Reports() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [plans, setPlans] = useState([]);
  const [rows, setRows] = useState([]);
  const [sendingoutOfferPlan, setSendingOutOfferPlan] = useState(null);
  const { formId, formField } = form;

  useEffect(() => {
    fetchSpecials();
    fetchPlans().then((data) => {
      if (data && data.length > 0) {
        setPlans(data);
      }
    });
  }, []);

  const handleSendCode = async (special_plan) => {
    setSendingOutOfferPlan(special_plan);
    setShowAddForm(true);
  };

  const columns = [
    { Header: "Plan", align: "left", accessor: "plan" },
    { Header: "Free Trial (Months)", align: "left", accessor: "free_months" },
    { Header: "Sent To", align: "left", accessor: "sent_count", type: "number" },
    { Header: "Redeemed", align: "left", accessor: "redeemed_count", type: "number" },
    {
      Header: "Actions",
      accessor: "action_buttons",
      align: "right",
      disableSort: true,
      buttons: [{ text: "Send", action: handleSendCode, color: "info" }],
    },
  ];

  const fetchSpecials = () => {
    fetchSpecialPlans().then((resp) => {
      const specials = [];
      resp.map((special) => {
        specials.push({
          id: special.id,
          plan: special.plan?.name,
          free_months: special.free_months,
          sent_count: special.sent_count,
          redeemed_count: special.redeemed_count ?? 0,
        });
      });
      setRows(specials);
      setIsLoading(false);
    });
  };

  const handleClosePopup = () => {
    setShowAddForm(false);
    setSendingOutOfferPlan(null);
  };

  const handleSubmit = async (values, actions) => {
    setIsLoading(true);
    await sendSpecialPlan({
      planID: sendingoutOfferPlan.id,
      emails: values.emails,
    });
    handleClosePopup();
    fetchSpecials();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox pb={3}>
        {isLoading ? (
          <SoftBox style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress color="inherit" />
          </SoftBox>
        ) : (
          <DataTable fullData={rows} optionType="" table={{ columns, rows }} loading={isLoading} canSearch />
        )}
      </SoftBox>
      <Footer />
      {showAddForm && (
        <Popup transparent={true}>
          <CloseIcon
            className="close-btn icon"
            onClick={() => {
              handleClosePopup();
            }}
          />
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {({ values, errors, touched, isSubmitting, handleChange, handleBlur }) => (
              <Form id={formId} autoComplete="off" style={{ width: "360px", padding: "0 20px" }}>
                <Card sx={{ height: "400px" }}>
                  <SoftBox p={3} pb={0}>
                    <SoftTypography variant="h5" fontWeight="medium">
                      {sendingoutOfferPlan.plan}
                      <br />({sendingoutOfferPlan.free_months} months trial)
                    </SoftTypography>
                  </SoftBox>
                  <SoftBox p={2}>
                    <SoftBox my={1.625}>
                      <SoftTypography variant="body2">Send To</SoftTypography>
                      <SoftInput multiline rows={5} name="emails" onBlur={handleBlur} onChange={handleChange} />
                    </SoftBox>
                    <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark" fullWidth>
                      Send
                    </SoftButton>
                  </SoftBox>
                </Card>
              </Form>
            )}
          </Formik>
        </Popup>
      )}
    </DashboardLayout>
  );
}

export default Reports;
